<template>
  <div class="row g-0" :class="{'flex-row-reverse': !even}">
    <div class="col-12 col-xl-6">
      <div class="row g-0 h-xl-50">
        <div class="col-12 col-md-6" v-if="tiles[even ? 0 : 1]">
          <Tile :tile="tiles[even ? 0 : 1]" size="small" :filters="filters"/>
        </div>
        <div class="col-12 col-md-6" v-if="tiles[even ? 1 : 2]">
          <Tile :tile="tiles[even ? 1 : 2]" size="small" :filters="filters"/>
        </div>
      </div>
      <div class="row g-0 h-xl-50" v-if="tiles[even ? 2 : 3]">
        <div class="col-12">
          <Tile :tile="tiles[even ? 2 : 3]" size="medium" :filters="filters"/>
        </div>
      </div>
    </div>
    <div class="col-12 col-xl-6" v-if="tiles[even ? 3 : 0]">
      <div class="col-12">
        <Tile :tile="tiles[even ? 3 : 0]" size="large" :filters="filters"/>
      </div>
    </div>
  </div>
</template>


<script setup>
import Tile from './Tile.vue'

const props = defineProps({
  tiles: Array,
  even: Boolean,
  filters: Object,
})

</script>
